/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SessionInputs */

const en_common_session = /** @type {(inputs: Common_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session`)
};

const es_common_session = /** @type {(inputs: Common_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión`)
};

/**
* | output |
* | --- |
* | "Session" |
*
* @param {Common_SessionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_session = /** @type {((inputs?: Common_SessionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SessionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_session(inputs)
	return en_common_session(inputs)
});